import { useState } from "react";

function useTabs(options, initialTab = null) {
  const [currentTab, setCurrentTab] = useState(initialTab || options[0]);

  const changeTab = (tab) => {
    if (options.includes(tab)) {
      setCurrentTab(tab);
    } else {
      console.warn("Invalid tab option:", tab);
    }
  };

  return {
    currentTab,
    setCurrentTab: changeTab,
  };
}

export default useTabs;
